import { Component, OnInit } from '@angular/core';
import { VerifypatientModule,PHIInfo,MadisonPHIdetails,getMadisonPHIdetails,PatientPersonalInfo, auth } from 'src/app/models/verifypatient/verifypatient';
import { ExitingpatientService } from 'src/app/services/exitingpatient.service';
import { PhrutillsService } from 'src/app/generic/phrutills.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

declare var $: any;

@Component({
  selector: 'app-madison-phi',
  templateUrl: './madison-phi.component.html',
  styleUrls: ['./madison-phi.component.css']
})
export class MadisonPHIComponent implements OnInit {


  madisonPHIdetails: MadisonPHIdetails = new MadisonPHIdetails();
  PHIdetails: PHIInfo = new PHIInfo();
  get_PHIdetails: getMadisonPHIdetails[] = [];
  patientPersonalInfo: PatientPersonalInfo;
   Is_deletedRec : boolean = false;
   Is_updatedRec : boolean = false;
   Is_addedRec : boolean = false;
   isNotValidPhone: boolean = false;
   isNotCellPhone: boolean = false;
  constructor(private _login: ExitingpatientService,private _router: Router,private _phrutilService: PhrutillsService,private phrUtils: PhrutillsService,private spinner: NgxSpinnerService) {

    let info = localStorage.getItem('PersonalInfo');
    this.patientPersonalInfo = this.phrUtils.decrypt(info) as PatientPersonalInfo;
    this.PHIdetails.patienT_ACCOUNT = this.patientPersonalInfo.PATIENT_ACCOUNT;
    this.PHIdetails.practicE_CODE = this.patientPersonalInfo.PRACTICE_CODE;
    this.GetPHIdetails()
   }

  ngOnInit(): void {
  }

  modalAddPHI(){

     this.madisonPHIdetails.iS_DELETED = '';
     this.madisonPHIdetails.disclosurE_ID = '';
     this.madisonPHIdetails.patienT_ACCOUNT = this.patientPersonalInfo.PATIENT_ACCOUNT;
     this.madisonPHIdetails.practicE_CODE = this.patientPersonalInfo.PRACTICE_CODE;
     this.Is_addedRec = true;
     this.Is_deletedRec = false;
     this.Is_updatedRec =false;
     $('#newphi').modal('show');

  }
  savePHIdeTails(){
  
  this.spinner.show();

  this._login.SavePHIdetails(this.madisonPHIdetails).subscribe((res: any) => {
     this.spinner.hide();
    if (res && res.statusCode == 200 && res.message.toLowerCase()=='success') {
      
      $('#delPHI').modal('hide');
      $('#newphi').modal('hide');

      if(this.Is_addedRec == true && this.Is_deletedRec === false && this.Is_updatedRec === false){
        this._phrutilService.showSuccess("PHI saved successfully.");
      }
      else if (this.Is_addedRec == false && this.Is_deletedRec === false && this.Is_updatedRec === true){
        this._phrutilService.showSuccess("PHI updated successfully.");
      }
      else if (this.Is_addedRec == false && this.Is_deletedRec === true && this.Is_updatedRec === false){
        this._phrutilService.showSuccess("PHI deleted successfully.");
      }
       this.madisonPHIdetails = new MadisonPHIdetails();
       this. GetPHIdetails();

    } else {
      this._phrutilService.showError("Some error occured.");
    }
  }, (error: any) => {
   
     this._phrutilService.showError("Some error occured.");
     this.spinner.hide();
  });
 
  }

  GetPHIdetails(){
  
   this.spinner.show();
   this._login.GetPHIdEtails(this.PHIdetails).subscribe((res: any) => {
     this.spinner.hide();
    if (res && res.statusCode == 200) {

      this.get_PHIdetails = res.data as getMadisonPHIdetails[];
           if(res && res.statusCode == 200 && res.message.toLowerCase().includes('no record found') ){
              this.get_PHIdetails=[];
             }
      
    } else {
     // this._phrutilService.showError("Some error occured.");
    }
  }, (error: any) => {
   
    // this._phrutilService.showError("Some error occured.");
     this.spinner.hide();
  });

  }

  editPHI(data: any){
    this.madisonPHIdetails = data;
    this.madisonPHIdetails.iS_DELETED = '';

     this.Is_addedRec = false;
     this.Is_deletedRec = false;
     this.Is_updatedRec =true;

    $('#newphi').modal('show');
  }
  deletePHI(data: any){
    this.madisonPHIdetails = data;
    this.madisonPHIdetails.iS_DELETED = '1';

    this.Is_addedRec = false;
     this.Is_deletedRec = true;
     this.Is_updatedRec =false;
    $('#delPHI').modal('show');
  }

  validatePhoneNo(field: any) {

    let phoneNumDigits = field.value.replace(/\D/g, '');
    field.value = phoneNumDigits;
    let isValidPhone = (phoneNumDigits.length == 0 || phoneNumDigits.length == 10);
    if (isValidPhone) {
      field.value = this._phrutilService.maskingPhoneNumer(phoneNumDigits);
      this.madisonPHIdetails. disclosurE_DESCRIPTION = field.value;
    } else {
      field.value = phoneNumDigits;
    }
  }
  validatePhone(phoneNumDigits: any, type: any) {
    let dummyPhone = phoneNumDigits.replace(/\D/g, '');
    phoneNumDigits = dummyPhone.replace(/\s/g, '');
    if (type == "phone") {
      if (phoneNumDigits.length == 0 || phoneNumDigits.length == 14 || phoneNumDigits.length == 10) {
        this.isNotValidPhone = false;
        if (phoneNumDigits.length != 0) {
          
          this.isNotCellPhone = false;
        }
      }
      else {
        this.isNotValidPhone = true;
      }
    }
  }

  nextComp(){

    if (this.get_PHIdetails.length > 0){
       this._router.navigateByUrl("/madison-ref")
       }
       else{
          this._phrutilService.showInfo("At least one record is mandatory.");
         return
       }
  }

}
